import React from 'react';
import {motion} from 'framer-motion';
import Cracked from '../images/Service Home/bg-image.png';
import image1 from '../images/Service Home/image1.png';
import image2 from '../images/Service Home/image2.png';
const ServiceHome = () => {
    
    return (
        <>
          <motion.div 
                initial={{ opacity: 0, y: -50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="self-stretch p-6 sm:p-8 md:p-12 bg-gradient-to-b from-secondary to-80% to-primary from-80% flex flex-col justify-start items-start gap-6 overflow-hidden"
            >
                <motion.div 
                    initial={{ opacity: 0, x: -50 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                    className="w-full flex flex-col lg:flex-row justify-center items-center gap-6 md:gap-8 lg:gap-10 overflow-hidden flex-grow"
                >
                    <motion.div 
                        initial={{ opacity: 0, x: -50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.5, delay: 0.4 }}
                        className="flex-1 w-full p-4 sm:p-6 md:p-8 flex flex-col justify-center items-end gap-6 md:gap-8 overflow-hidden"
                    >
                        <div className="w-full flex flex-col justify-start items-center lg:items-start gap-6 md:gap-10">
                            <div className="w-full text-center lg:text-left text-primary text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-semibold font-playfair-display">
                                About Lumi Glass
                            </div>
                            <div className="w-full text-center lg:text-left text-primary text-sm sm: md:text-lg lg:text-xl xl:text-2xl font-normal font-nunito-sans leading-relaxed">
                                We have been a family-owned-and-operated business for more than 40 years. We pride ourselves on providing personal attention to our customers. Whether you need windshield, auto glass, desktop, or mirror repairs or installations, we’re the BEST!<br/><br/>
                                We offer a wide range of services and have the skills and experience to back it up.<br/><br/>
                                However, you will find our prices are not only competitive, but much lower than our competition’s in many cases.<br/><br/>
                                Whether you have a small chip in your windshield or need a whole new storefront, we can help.
                            </div>
                        </div>
                    </motion.div>
                    <motion.div 
                        initial={{ opacity: 0, x: 50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.5, delay: 0.4 }}
                        className="flex-1 w-full p-4 sm:p-6 md:p-8 flex flex-col justify-center items-start gap-6 md:gap-8 overflow-hidden"
                    >
                        <img className="w-full h-auto max-h-[400px] sm:max-h-[500px] md:max-h-[600px] lg:max-h-[700px] object-cover rounded-lg" src={image1} alt="Placeholder" />
                    </motion.div>
                </motion.div>
                <motion.div 
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.6 }}
                    className="w-full flex flex-col lg:flex-row justify-center items-center gap-6 md:gap-8 lg:gap-10 overflow-hidden"
                >
                    <motion.div 
                        initial={{ opacity: 0, scale: 0.8 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.5, delay: 0.8 }}
                        className="flex-1 h-52 sm:h-56 md:h-64 lg:h-72 p-4 sm:p-6 md:p-8 flex flex-col justify-center items-end gap-6 md:gap-8 overflow-hidden"
                    >
                        <img className="w-full h-full object-cover rounded-lg" src={image2} alt="Placeholder" />
                    </motion.div>
                    <motion.div 
                        initial={{ opacity: 0, scale: 0.8 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.5, delay: 1 }}
                        className="flex-1 h-48 sm:h-56 md:h-64 lg:h-72 p-4 sm:p-6 md:p-8 flex flex-col justify-start items-center gap-6 md:gap-8 overflow-hidden"
                    >
                        <div className="inline-flex justify-start items-center gap-4">
                            <div className="text-center text-primary text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-semibold font-nunito-sans">40</div>
                            <div className="text-center lg:text-left text-primary text-sm sm: md:text-lg lg:text-xl xl:text-2xl font-normal font-nunito-sans">
                                years of <br /> experience
                            </div>
                        </div>
                    </motion.div>
                </motion.div>
            </motion.div>
               <motion.div
            className="w-full self-stretch px-6 sm:px-8 md:px-12 py-12 sm:py-16 md:py-20 inline-flex flex-col justify-center items-center gap-6 md:gap-8 bg-primary"
            style={{
                backgroundImage: `url(${Cracked})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
            }}
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
        >
            <motion.div
                className="w-full max-w-4xl p-6 sm:p-8 md:p-10 bg-primary bg-opacity-75 rounded-lg outline outline-1 outline-offset-[-1px] outline-accent backdrop-blur-md flex flex-col justify-between items-center gap-6"
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
            >
                <motion.div
                    className="text-center text-accent text-lg sm:text-xl md:text-2xl lg:text-3xl font-normal font-nunito-sans"
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.4 }}
                >
                    The services we offer Especially for you
                </motion.div>
                <motion.div
                    className="text-center text-accent sm:text-lg md:text-xl lg:text-2xl font-normal font-nunito-sans"
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.6 }}
                >
                    We have Certified auto glass experts you can trust
                </motion.div>
                <motion.div
                    className="flex flex-col sm:flex-row justify-center items-center gap-6 md:gap-8"
                    initial="hidden"
                    animate="visible"
                    variants={{
                        hidden: { opacity: 0 },
                        visible: {
                            opacity: 1,
                            transition: {
                                staggerChildren: 0.2,
                            },
                        },
                    }}
                >
                    <motion.div
                        className="w-full h-auto px-6 sm:px-8 py-6 sm:py-8 rounded-2xl flex flex-col justify-start items-center gap-6"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                    >
                        <div className="text-center text-accent sm:text-lg md:text-xl font-normal font-nunito-sans">
                            Stress-free claims
                        </div>
                        <div className="text-center text-accent text-sm sm: md:text-lg font-normal font-nunito-sans leading-relaxed">
                            We partner with most insurance companies to make your experience seamless. Rest easy while we verify your coverage and file your claim.
                        </div>
                    </motion.div>
                    <motion.div
                        className="w-full h-auto px-6 sm:px-8 py-6 sm:py-8 rounded-2xl flex flex-col justify-start items-center gap-6"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.2 }}
                    >
                        <div className="text-center text-accent sm:text-lg md:text-xl font-normal font-nunito-sans">
                            Service near you
                        </div>
                        <div className="text-center text-accent text-sm sm: md:text-lg font-normal font-nunito-sans leading-relaxed">
                            Schedule service at your nearest location, or have us come to you. You’ll find our Bob's Glass Works and repair facility in Jersey City, NJ.
                        </div>
                    </motion.div>
                    <motion.div
                        className="w-full h-auto px-6 sm:px-8 py-6 sm:py-8 rounded-2xl flex flex-col justify-start items-center gap-6"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.4 }}
                    >
                        <div className="text-center text-accent sm:text-lg md:text-xl font-normal font-nunito-sans">
                            lifetime warranty
                        </div>
                        <div className="text-center text-accent text-sm sm: md:text-lg font-normal font-nunito-sans leading-relaxed">
                            We back our work with a  lifetime warranty on auto glass replacements and a  guarantee on repairs and recalibrations.
                        </div>
                    </motion.div>
                </motion.div>
            </motion.div>
        </motion.div>
                 {/* <motion.div
            className="self-stretch flex flex-col justify-start items-start py-24"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
        >
          
            <motion.div
                className="self-stretch p-8 bg-secondary flex flex-col justify-center items-center"
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.2 }}
            >
                <motion.div
                    className="w-full max-w-6xl h-auto bg-accent shadow-md outline outline-[4px] rounded-md outline-primary flex flex-col-reverse lg:flex-row justify-between items-center overflow-hidden"
                    initial={{ scale: 0.8, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                >
                    <motion.div
                        className="flex-1 p-4 lg:p-8 flex flex-col justify-center items-start gap-6"
                        initial={{ opacity: 0, x: -50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6 }}
                    >
                        <div className="flex flex-col justify-start items-start gap-4">
                            <div className="text-primary text-2xl lg:text-3xl font-normal font-nunito-sans">
                                Auto Glass Services
                            </div>
                            <div className="flex flex-col justify-start items-start gap-2">
                                <p className="text-base lg:text-lg text-primary font-normal font-nunito-sans">
                                    Automatic White Balance (AWB): Whether the background is shade or sun, or some of both, the HookCam® delivers a constant image.
                                </p>
                                <p className="text-base lg:text-lg text-primary font-normal font-nunito-sans">
                                    Hi Resolution: 690 Hi Resolution TV Lines (HTVL).
                                </p>
                                <p className="text-base lg:text-lg text-primary font-normal font-nunito-sans">
                                    Lens Protection: Embedded lens is recessed in epoxy and smear–free.
                                </p>
                                <Link
                                    to="/services/auto"
                                    className="px-6 py-3 bg-primary text-accent rounded-md font-nunito-sans hover:bg-accent hover:text-primary transition"
                                >
                                    Learn More
                                </Link>
                            </div>
                        </div>
                    </motion.div>
                    <motion.img
                        className="w-full lg:w-[469px] h-64 lg:h-auto object-cover"
                        src={image3}
                        alt="Auto Glass Services"
                        initial={{ opacity: 0, x: 50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6 }}
                    />
                </motion.div>
            </motion.div>
        
            <motion.div
                className="self-stretch p-8 bg-secondary flex flex-col justify-center items-center"
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.4 }}
            >
                <motion.div
                    className="w-full max-w-6xl h-auto bg-accent shadow-md outline outline-[4px] rounded-md outline-primary flex flex-col lg:flex-row justify-between items-center overflow-hidden"
                    initial={{ scale: 0.8, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                >
                    <motion.img
                        className="w-full lg:w-[469px] h-64 lg:h-auto object-cover"
                        src={image4}
                        alt="Residential Glass Services"
                        initial={{ opacity: 0, x: -50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6 }}
                    />
                    <motion.div
                        className="flex-1 p-4 lg:p-8 flex flex-col justify-center items-start gap-6"
                        initial={{ opacity: 0, x: 50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6 }}
                    >
                        <div className="flex flex-col justify-start items-start gap-4">
                            <div className="text-primary text-2xl lg:text-3xl font-normal font-nunito-sans">
                                Residential Glass Services
                            </div>
                            <div className="flex flex-col justify-start items-start gap-2">
                                <p className="text-base lg:text-lg text-primary font-normal font-nunito-sans">
                                    Automatic White Balance (AWB): Whether the background is shade or sun, or some of both, the HookCam® delivers a constant image.
                                </p>
                                <p className="text-base lg:text-lg text-primary font-normal font-nunito-sans">
                                    Hi Resolution: 690 Hi Resolution TV Lines (HTVL).
                                </p>
                                <p className="text-base lg:text-lg text-primary font-normal font-nunito-sans">
                                    Lens Protection: Embedded lens is recessed in epoxy and smear–free.
                                </p>
                                <Link
                                    to="/services/residential"
                                    className="px-6 py-3 bg-primary text-accent rounded-md font-nunito-sans hover:bg-accent hover:text-primary transition"
                                >
                                    Learn More
                                </Link>
                            </div>
                        </div>
                    </motion.div>
                </motion.div>
            </motion.div>
        
            <motion.div
                className="self-stretch p-8 bg-secondary flex flex-col justify-center items-center"
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.6 }}
            >
                <motion.div
                    className="w-full max-w-6xl h-auto bg-accent shadow-md outline outline-[4px] rounded-md outline-primary flex flex-col-reverse lg:flex-row justify-between items-center overflow-hidden"
                    initial={{ scale: 0.8, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                >
                    <motion.div
                        className="flex-1 p-4 lg:p-8 flex flex-col justify-center items-start gap-6"
                        initial={{ opacity: 0, x: -50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6 }}
                    >
                        <div className="flex flex-col justify-start items-start gap-4">
                            <div className="text-primary text-2xl lg:text-3xl font-normal font-nunito-sans">
                                Commercial Glass Services
                            </div>
                            <div className="flex flex-col justify-start items-start gap-2">
                                <p className="text-base lg:text-lg text-primary font-normal font-nunito-sans">
                                    Automatic White Balance (AWB): Whether the background is shade or sun, or some of both, the HookCam® delivers a constant image.
                                </p>
                                <p className="text-base lg:text-lg text-primary font-normal font-nunito-sans">
                                    Hi Resolution: 690 Hi Resolution TV Lines (HTVL).
                                </p>
                                <p className="text-base lg:text-lg text-primary font-normal font-nunito-sans">
                                    Lens Protection: Embedded lens is recessed in epoxy and smear–free.
                                </p>
                                <Link
                                    to="/services/commercial"
                                    className="px-6 py-3 bg-primary text-accent rounded-md font-nunito-sans hover:bg-accent hover:text-primary transition"
                                >
                                    Learn More
                                </Link>
                            </div>
                        </div>
                    </motion.div>
                    <motion.img
                        className="w-full lg:w-[469px] h-64 lg:h-auto object-cover"
                        src={image5}
                        alt="Commercial Glass Services"
                        initial={{ opacity: 0, x: 50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6 }}
                    />
                </motion.div>
            </motion.div>
        </motion.div> */}
        </>
    );
};

export default ServiceHome;
